module.exports = __webpack_public_path__ + "static/media/zoom-icon.c377608c.svg";